import { Typography } from "@mui/material";

const Typo = ({ style, type, param }) => {
  return (
    <Typography sx={style} component={type}>
      {param}
    </Typography>
  );
};
export default Typo;
